import { render, staticRenderFns } from "./LocationPolygon.vue?vue&type=template&id=fd79160a&"
import script from "./LocationPolygon.vue?vue&type=script&lang=js&"
export * from "./LocationPolygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports